var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coche"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.53822 15C5.47323 15 5.40937 14.9836 5.35298 14.9526C5.29658 14.9215 5.24961 14.8767 5.21671 14.8228C3.8232 12.5372 0.109869 7.67299 0.0725137 7.62411C0.0194577 7.55468 -0.00587378 7.46919 0.00114936 7.38327C0.00817251 7.29734 0.0470812 7.21672 0.110764 7.15613L1.25222 6.07027C1.31423 6.01127 1.39576 5.97507 1.48263 5.96794C1.5695 5.96082 1.65621 5.98324 1.7277 6.03129L5.46049 8.54061C7.94218 5.4714 10.2484 3.35325 11.7643 2.10519C13.4633 0.706074 14.5436 0.07738 14.5887 0.0511799C14.6467 0.0176941 14.713 3.29724e-06 14.7806 4.80752e-09H16.6271C16.7027 -1.19018e-05 16.7765 0.0220929 16.8387 0.0633834C16.901 0.104674 16.9487 0.1632 16.9756 0.231201C17.0025 0.299202 17.0073 0.373467 16.9893 0.444148C16.9714 0.514829 16.9315 0.578588 16.8751 0.626971C14.1375 2.97421 11.2914 6.7037 9.38587 9.41892C7.31445 12.3703 5.87646 14.7946 5.86218 14.8187C5.82981 14.8734 5.78307 14.919 5.72664 14.9508C5.6702 14.9826 5.60607 14.9996 5.54068 15L5.53822 15Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4a797bee1506b4fdf421f3a48960cc83.svg";
export { ForwardRef as ReactComponent };